import { ReactElement } from "react";
import { useDependency } from "../../../../contexts/DependencyContext";
import { ComponentModelService } from "../../../../services/ComponentModelService";
import { DateService } from "../../../../services/types/DateService";
import { className } from "../../../../shared/helpers";
import styles from "./Summary.module.scss";

interface SummaryProps
{
    description: string;
}

const Summary = (props: SummaryProps): ReactElement =>
{
    const service = useDependency(ComponentModelService);
    const { component, properties } = service.componentModel;
    const hasData = !!component && !!properties;
    const dateService = useDependency(DateService);

    return (
        hasData && <div {...className(styles.summary, "scroll-container")}>
            <h4 className="highlighted">Description</h4>
            <div className={styles.contentBlock}>
                {props.description && (<div>
                    <p><span className="highlighted">Description:</span> {props.description}</p>
                </div>)}

                <div>
                    <p><span className="highlighted">Code:</span> {component.code}</p>
                </div>

                <div>
                    <p><span className="highlighted">Type:</span> {component.componentTypeName}</p>
                </div>

                {component.location && (
                    <div>
                        <p><span className="highlighted">Location:</span> {component.location}</p>
                    </div>)
                }
            </div>

            {properties.length > 0 && <>
                <h4 className="highlighted">Properties</h4>
                <div className={styles.contentBlock}>
                    <table>
                        <tbody>
                            {properties.map((property, i) => (
                                <tr key={i}>
                                    <td className={styles.propertyName}>
                                        <span className="highlighted">{property.name}</span>
                                    </td>
                                    <td>
                                        {property.valueText ||
                                         property.valueNumber ||
                                         (property.valueBoolean && property.valueBoolean ? 'yes' : 'no' ) ||
                                         (property.valueDateTime && dateService.format(new Date(property.valueDateTime), "MM/dd/yyyy HH:mm:ss"))}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </>}
        </div>
    );
}

export default Summary;